var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"simple-text"},[_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{staticClass:"content",attrs:{"cols":"12","lg":"10"},domProps:{"innerHTML":_vm._s(_vm.payload.content)}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }